import { registerComponent } from "react_mount"

registerComponent("profile-newsletters-page", () => import("components/Profile/Newsletters/Page"))
